import script from "./UnitStatCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UnitStatCard.vue?vue&type=script&setup=true&lang=js"

import "./UnitStatCard.vue?vue&type=style&index=0&id=e540f6a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e540f6a4"]])

export default __exports__